import React from 'react';
import MondaySyncPage from '../../pages/MondaySyncPage';

const MondaySyncTab = () => {
  return <MondaySyncPage embedded />;
};

export default MondaySyncTab;
